import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.object.freeze";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { LocalizableMessage } from 'components/LocalizableMessage/LocalizableMessage';
import { apiErrorMessages } from './Error.messages';
export var isBillingError = function isBillingError(error) {
  return error && error.code >= 4301 && error.code <= 4320;
}; // NOTE: this is a hack so that sagas can universally represent the generic error message

export var GENERIC_ERROR = Object.freeze({
  isGenericError: true
});
export var ApiError =
/*#__PURE__*/
function (_Component) {
  _inherits(ApiError, _Component);

  function ApiError() {
    _classCallCheck(this, ApiError);

    return _possibleConstructorReturn(this, _getPrototypeOf(ApiError).apply(this, arguments));
  }

  _createClass(ApiError, [{
    key: "errors",
    value: function errors() {
      var _this$props = this.props,
          errors = _this$props.errors,
          error = _this$props.error;
      return (errors || []).concat(error).filter(function (err) {
        return !!err;
      });
    }
  }, {
    key: "surfacedErrorCodes",
    value: function surfacedErrorCodes() {
      var _this$props2 = this.props,
          surfacedErrorCodes = _this$props2.surfacedErrorCodes,
          surfacedErrorCode = _this$props2.surfacedErrorCode;
      return (surfacedErrorCodes || []).concat(surfacedErrorCode).filter(function (code) {
        return !!code;
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          extraClasses = _this$props3.extraClasses,
          reduce = _this$props3.reduce;
      var errors = this.errors();
      var codes = this.surfacedErrorCodes();

      if (!errors.length) {
        return false;
      }

      var message = ApiError.messageForDisplay(errors, reduce, codes);
      return React.createElement("div", {
        className: "error__text ".concat(extraClasses || '')
      }, React.createElement(LocalizableMessage, {
        message: message
      }));
    }
  }], [{
    key: "billingErrorReducer",
    value: function billingErrorReducer(memo, error) {
      if (error && (error.code === 4608 || isBillingError(error))) {
        return error;
      }

      return memo;
    }
  }, {
    key: "extractMessage",
    value: function extractMessage(error) {
      if (typeof error === 'string') {
        return error;
      }

      if (error && error.code === 4608) {
        return apiErrorMessages.suspect;
      }

      if (error && [4313, 4314, 4315].includes(error.code)) {
        return apiErrorMessages.billingError;
      }

      if (error && error.message) {
        return error.message;
      }

      if (error && error.details) {
        return error.details;
      }

      return apiErrorMessages.genericMessage;
    }
  }, {
    key: "messageForDisplay",
    value: function messageForDisplay(errors, reducer) {
      var codes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

      var reducerToUse = reducer || function (memo, err) {
        return codes.indexOf(err.code) !== -1 ? err : memo;
      };

      var error = (errors || []).reduce(reducerToUse, null);
      return ApiError.extractMessage(error);
    }
  }]);

  return ApiError;
}(Component);
var errorShape = PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.bool]);
ApiError.propTypes = {
  error: errorShape,
  errors: PropTypes.arrayOf(errorShape),
  extraClasses: PropTypes.string,
  reduce: PropTypes.func,
  surfacedErrorCode: PropTypes.number,
  surfacedErrorCodes: PropTypes.arrayOf(PropTypes.number)
};